export enum OrderByOperator {
  ASC = 'ASC',
  DESC = 'DESC',
}
